import useSWRImmutable from 'swr/immutable';
import InvoiceService from '@/services/InvoiceService';

const useInvoiceGraphs = () => useSWRImmutable(
    'invoice-graphs',
    InvoiceService.getInvoiceGraphs,
);

export default useInvoiceGraphs;
